import React from "react";
import HeaderInner from "../header/HeaderInner";
import Breadcrumb from "../inner/Breadcrumb";
import AboutOne from "../elements/AboutOne";
import TestimonialsBrand from "../elements/TestimonialsBrand";
import Footer from "../elements/Footer";

// DATA
import { DataBrandsOne } from "../data/DataBrands";
import {
  DataAboutPageSec1,
  DataAboutPageSec2,
  DataAboutPageSec3,
} from "../data/DataAbout";
import AboutSix from "../elements/AboutSix";
import AboutTwo from "../elements/AboutTwo";
// Data
import { DataNav } from "../data/DataNav";

function about() {
  const dataBreadcrumb = DataNav[1];

  return (
    <div className="index-one">
      <HeaderInner />
      <main>
        <Breadcrumb props={dataBreadcrumb} />

        <AboutOne dataAbout={DataAboutPageSec1} />

        <div className="tpm-services-process-area tmp-section-gap bg-working-1">
          <AboutSix DataAbout={DataAboutPageSec2} />
        </div>

        <div style={{ paddingTop: "120px" }}></div>

        <AboutTwo dataAbout={DataAboutPageSec3} />

        <TestimonialsBrand dataBrands={DataBrandsOne} />
        <Footer />
      </main>
    </div>
  );
}

export default about;
